import React from "react";
import DatePicker from "react-datepicker";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import SiteProfileTable from "./SiteProfileTable/SiteProfileTable";
import Button from "@material-ui/core/Button";
import BusinessIcon from "@material-ui/icons/Business";
import FloorPlan from "./FloorPlan/FloorPlan";
import BackspaceIcon from "@material-ui/icons/Backspace";
import { IsSectionVisible } from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";

class SiteProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyId"),
      startDate: localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L"), // localStorage.getItem("selectedstartDate"),
      endDate: localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L"),
      PickerStartDate: localStorage.getItem("selectedstartDate")
        ? new Date(
            moment(localStorage.getItem("selectedendDate")) > new Date()
              ? new Date()
              : moment(localStorage.getItem("selectedendDate"))
                  .startOf("month")
                  .format("L")
          )
        : new Date(),
      view: "SiteProfile",
      rerender: false,
      isChanged: true
    };

    localStorage.setItem(
      "selectedstartDate",
      localStorage.getItem("selectedstartDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .startOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .startOf("month")
            .format("L")
    );
    localStorage.setItem(
      "selectedendDate",
      localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .endOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L")
    );

    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem(
      "MTDDefault",
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("MM")
    );
    localStorage.setItem("yearDefault", [
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("YYYY"),
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("YYYY")
    ]);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }
  }

  /** text field change */
  _handleTextFieldChange = e => {
    const input = e;
    const output = moment(input, "YYYY-MM");
    localStorage.setItem(
      "selectedstartDate",
      output.startOf("month").format("L")
    );
    localStorage.setItem("selectedendDate", output.endOf("month").format("L"));
    this.setState({
      startDate: output.startOf("month").format("L"),
      endDate: output.endOf("month").format("L"),
      PickerStartDate: e
    });
  };

  /** property selection */
  onPropertySelect = id => {
    localStorage.setItem("selectedPropertyId", id);
    localStorage.setItem(
      "totalSqf",
      ((this.state.datacenterList || []).find(x => x.propertyID == id) || {})
        .nrarsf
    );

    this.setState({ selectedPropertyId: id });
  };

  /** Data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList
        });
      }
    );
  };

  /** call on update */
  onUpdate = () => {
    const {rerender}= this.state;
    this.setState({ rerender: !rerender });
  };

  /** site profile converter */
  changeToSiteProfile = () => {
    this.getDataCenterList();
    this.setState({
      view: "SiteProfile"
    });
  };
  
  render() {
    const DataHallCapacity = IsSectionVisible(
      SECTIONS.SITE_PROFILE,
      SECTIONS.DATA_HALL_CAPACITY
    );
    const SitePlan = IsSectionVisible(
      SECTIONS.SITE_PROFILE,
      SECTIONS.SITE_PLAN
    );
    const TenantListing = IsSectionVisible(
      SECTIONS.SITE_PROFILE,
      SECTIONS.TENANT_LISTING
    );

    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container className={"reports-row-one"}>
            <Grid item xs={12} md={6}>
              <Box className={"w-25 reports-dcList"}>
                <DatacenterList
                  dataSource={this.state.datacenterList}
                  onPropertySelect={this.onPropertySelect}
                  classTitle={"dc-list-reports"}
                  selectedPropertyId={this.state.selectedPropertyId}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6} justifyContent={"flex-end"}>
              {SitePlan && (
                <Box className={"reports-datepicker"}>
                  {this.state.view == "SiteProfile" ? (
                    <>
                      {false && (
                        <Button
                          variant={"contained"}
                          size={"small"}
                          style={{ marginRight: "10px" }}
                          onClick={() => this.setState({ view: "SitePlan" })}
                          startIcon={
                            <BusinessIcon
                              fontSize={"inherit"}
                              style={{ color: "var(--common--Text--color)" }}
                            />
                          }
                        >
                          {"Site Plan\r"}
                        </Button>
                      )}{" "}
                      <DatePicker
                        selected={this.state.PickerStartDate}
                        onChange={date => this._handleTextFieldChange(date)}
                        dateFormat={"MMMM yyyy"}
                        showMonthYearPicker
                        maxDate={new Date()}
                        popperPlacement={"bottom-end"}
                      />
                    </>
                  ) : (
                    <Button
                      variant={"contained"}
                      size={"small"}
                      style={{ marginRight: "10px" }}
                      onClick={this.changeToSiteProfile}
                      startIcon={
                        <BackspaceIcon
                          fontSize={"inherit"}
                          style={{ color: "var(--common--Text--color)" }}
                        />
                      }
                    >
                      {"Site Profile\r"}
                    </Button>
                  )}
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        {this.state.view == "SiteProfile" &&
        (TenantListing || DataHallCapacity) ? (
          <>
            {TenantListing && (
              <Grid item xs={12}>
                <Box>
                  <SiteProfileTable
                    propertyId={this.state.selectedPropertyId}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    table={"lease"}
                    onUpdate={this.onUpdate}
                    datacenterList={this.state.datacenterList}
                    isChanged={this.state.isChanged}
                  />
                </Box>
              </Grid>
            )}
            {DataHallCapacity && (
              <Grid item xs={12}>
                <Box mt={3}>
                  <SiteProfileTable
                    propertyId={this.state.selectedPropertyId}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    table={"capacity"}
                    rerender={this.state.rerender}
                    datacenterList={this.state.datacenterList}
                    isChanged={this.state.isChanged}
                  />
                </Box>
              </Grid>
            )}
          </>
        ) : (
          <>
            {SitePlan ? (
              <Grid item xs={12}>
                <Box>
                  <FloorPlan propertyId={this.state.selectedPropertyId} />
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </>
        )}
      </Grid>
    );
  }
}
export default SiteProfile;
